import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import { Footer } from '../../components';

import { Sidebar, Topbar } from './components';
import UserMessaging from '../../views/UserMessaging';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    },
    display: 'flex',
    flexDirection: 'column'
  },
  shiftContent: {
    paddingLeft: 240
  },
  topBar: {
    flexGrow: 0
  },
  content: {
    flexGrow: 1
  },
  footer: {
    flexGrow: 0
  }
}));

const Main = props => {
  const { children, userMessageDomain } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}>
      <Topbar onSidebarOpen={handleSidebarOpen} className={classes.topBar} />
      <UserMessaging userMessageDomain={userMessageDomain} />
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <main className={classes.content}>{children}</main>
      <Footer className={classes.footer} />
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
